import { BoardService } from '@common/lib/api';
import to from '@common/lib/common/to';
import * as board from './types';
import { downloadFile } from '@common/lib/common/utils';
//import * as common from '@common/store/modules/common/types';
//import * as commonGetters from '@common/store/modules/common/getters';

const actions = {
  async [board.BOARD_ARTICLE_RESET_STATE](context) {
    context.commit(board.BOARD_ARTICLE_RESET_STATE);
  },

  async [board.BOARD_ARTICLES_RESET_STATE](context) {
    context.commit(board.BOARD_ARTICLES_RESET_STATE);
  },

  async [board.CREATE_ARTICLE](context, params) {
    const { data } = await BoardService.add(params);

    return data;
  },
  async [board.CREATE_KEYWORD_INQUIRY](context, params) {
    const { data } = await BoardService.addKeywordInquiry(params);

    return data;
  },
  async [board.FETCH_ARTICLE](context, params) {
    const { data } = await BoardService.getById(params);
    context.commit(board.SET_ARTICLE, data);

    return data;
  },
  async [board.UPDATE_ARTICLE](context, payload) {
    const { data } = await BoardService.modifyById(payload);

    return data;
  },
  async [board.DELETE_ARTICLE](context, payload) {
    const { data } = await BoardService.removeById(payload);

    return data;
  },
  async [board.FETCH_ARTICLE_LIST](context, params) {
    const { data } = await BoardService.search(params);
    if (params.toArticles2) data.toArticles2 = true;
    if (params.toArticles3) data.toArticles3 = true;
    context.commit(board.SET_ARTICLES, data);

    return data;
  },
  async [board.FETCH_KEYWORD_ARTICLE_LIST](context, params) {
    const { data } = await BoardService.searchKeywordInquiry(params);
    context.commit(board.SET_ARTICLES, data);
    return data;
  },
  async [board.EXCEL_DOWNLOAD_ARTICLE_LIST](context, params) {
    const response = await BoardService.downloadKeywordInquiry(params);
    downloadFile(response);
  },
};

export default actions;
